// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"ca38a7c7","686":"2b6818b6"}[chunkId] + ".chunk.js";
};